const defaultFeatures = {
  customTourOperatorSelection: true,
  SSRDimensions: true,
  seatTrade: true,
  checkOutPassenger: true,
  leaveAtGate: true,
  addInfantToBooking: true,
  showGlobalMessage: false,
  allowedToAccess: true,
}

export default {
  ...defaultFeatures,
  ...window.features,
}
